export default from './DeleteModal';



// WEBPACK FOOTER //
// ./src/components/common/Modals/DeleteModal/index.js